import storage from "@/utils/storage"
import { fetchData } from "@/utils/fetch"
import { useStore } from 'vuex'

/**
 * 特定场景下使用
 * 判断当前缓存的currency是否最新，让页面金额正确显示
*/
export const useCurrencyJudge = () => {
  const store = useStore()
  const storageCurrency = storage.get('currencyData')

  const judgeCurrency = async () => {
    const { code, data } = await fetchData(
      '/dsp-app/alibaba-common/currencyList'
    )
    if (code === 200) {
      const target = data.find(item => item.targetCurrency === storageCurrency.targetCurrency)
      if (target.rate !== storageCurrency.rate) {
        storage.set('currencyData', target)
        store.commit('setCurrencyData', target)
      }
    }
  }

  return {
    judgeCurrency
  }
}